import { create } from "zustand";

interface PlayBackState {
  loadingStates: Record<number, boolean>;
  audioURLs: Record<number, string>;
  setLoadingState: (id: number, isLoading: boolean) => void;
  setAudioURL: (id: number, url: string) => void;
}

export const usePlayBackStore = create<PlayBackState>((set) => ({
  loadingStates: {},
  audioURLs: {},
  setLoadingState: (id, isLoading) =>
    set((state) => ({
      loadingStates: {
        ...state.loadingStates,
        [id]: isLoading,
      },
    })),
  setAudioURL: (id, url) =>
    set((state) => ({
      audioURLs: {
        ...state.audioURLs,
        [id]: url,
      },
    })),
}));
